
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-cta-gradient opacity-10 -z-10"></div>
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto bg-white rounded-3xl p-12 md:p-16 shadow-xl border border-gray-100 relative overflow-hidden animate-scale-in">
          {/* Background decoration */}
          <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-gradient-radial from-h44s-yellow/30 to-transparent rounded-full -z-10"></div>
          <div className="absolute -top-16 -left-16 w-64 h-64 bg-gradient-radial from-h44s-pink/30 to-transparent rounded-full -z-10"></div>
          
          <div className="flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="md:w-2/3">
              <div className="inline-block px-3 py-1 mb-6 rounded-full bg-purple-50 border border-purple-100">
                <span className="text-sm font-medium text-h44s-purple">Got a 🧠 project in mind?</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">Let's collaborate on your next venture. 🔥</h2>
              <p className="text-lg text-gray-700 mb-8 text-balance">
                Whether you're looking to invest in one of our existing businesses or bring a new idea to life, 
                I'm excited to hear from you. Let's build something remarkable together.
              </p>
            </div>
            
            <div className="flex flex-col space-y-4 w-full md:w-auto">
              <Link to="/contact">
                <Button className="w-full md:w-auto px-8 py-6 bg-gradient-to-r from-h44s-blue to-h44s-purple text-white shadow-button button-shine">
                  Get in Touch
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link to="/schedule-call">
                <Button variant="outline" className="w-full md:w-auto px-8 py-6 text-gray-800 border-gray-300 hover:bg-gray-50">
                  Schedule a Call
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
